import React, { useState } from "react";
import {
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@material-ui/core";
import ShowcaseModal from "./ShowcaseModal";

// Update props to include user status and data
const CustomSessionForm = ({
  onSubmit,
  isLoading,
  authStatus,
  userData,
  setError,
}) => {
  const [topic, setTopic] = useState("");
  const [difficulties, setDifficulties] = useState([]);
  const [showcaseModalOpen, setShowcaseModalOpen] = useState(false);
  const difficultyOptions = [
    { label: "Entry", value: "Entry" },
    { label: "Junior", value: "Junior" },
    { label: "Middle", value: "Middle" },
    { label: "Senior", value: "Senior" },
    { label: "Expert", value: "Expert" },
  ];

  const handleDifficultyChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setDifficulties((prev) => [...prev, value]);
    } else {
      setDifficulties((prev) => prev.filter((d) => d !== value));
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (topic && difficulties.length > 0) {
      if (authStatus === "anonymous") {
        setShowcaseModalOpen(true);
      } else {
        onSubmit(topic, difficulties);
      }
    } else {
      alert("Please select a topic and at least one difficulty level.");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        width: "100%",
        maxWidth: "600px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <TextField
        label="Topic"
        variant="outlined"
        value={topic}
        onChange={(e) => setTopic(e.target.value)}
        disabled={isLoading}
        fullWidth
        required
      />
      <div>
        <Typography variant="subtitle1" style={{ marginBottom: "8px" }}>
          Niveaux de difficulté
        </Typography>
        <FormGroup row>
          {difficultyOptions.map((option) => (
            <FormControlLabel
              key={option.value}
              control={
                <Checkbox
                  value={option.value}
                  checked={difficulties.includes(option.value)}
                  onChange={handleDifficultyChange}
                  disabled={isLoading}
                  color="primary"
                />
              }
              label={option.label}
            />
          ))}
        </FormGroup>
      </div>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        // Update disabled logic based on auth status and user data
        disabled={
          isLoading || // Already loading a session
          authStatus === "loading" || // Auth state not yet determined
          // TODO: Move the logic disabled to an advert to upgrade premium modal. To motivate buy
          // authStatus === "anonymous" || // Anonymous users cannot use the form directly
          (authStatus === "loggedIn" &&
            !userData.isPremium &&
            userData.hasUsedShowcaseSession) || // Non-premium used showcase
          (authStatus === "loggedIn" &&
            userData.isPremium &&
            userData.credits < 4) || // Premium insufficient credits
          !topic || // Topic not entered
          difficulties.length === 0 // No difficulty selected
        }
        fullWidth
        style={{ marginTop: "16px" }}
      >
        {isLoading ? "Generation..." : "Générer votre session personnalisée"}
      </Button>
      {/* Premium Required Modal */}
      <ShowcaseModal
        open={showcaseModalOpen}
        handleClose={() => setShowcaseModalOpen(false)}
      />
    </form>
  );
};

export default CustomSessionForm;
